import React from "react";
import PropTypes from "prop-types";
import {
    Box,
    IconButton,
    Tooltip,
    Typography
} from "@mui/material";
import HelpIcon from "@mui/icons-material/HelpOutline";
import MainCard from "../../../components/cards/MainCard";
import LoadingSwitch from "../../../components/LoadingSwitch";
import { getCardColor } from "../../../utils/colorUtils";
import { useTheme } from "@mui/material/styles";

MfaSettings.propTypes = {
    tenancyData: PropTypes.object.isRequired,
    loadingStates: PropTypes.object.isRequired,
    isAnySwitchLoading: PropTypes.func.isRequired,
    onSwitchChange: PropTypes.func.isRequired
};

export default function MfaSettings({
    tenancyData,
    loadingStates,
    isAnySwitchLoading,
    onSwitchChange
}) {
    const theme = useTheme();
    const lightMode = theme.palette.mode === "light";

    return (
        <MainCard
            content={true}
            boxShadow={true}
            border={false}
            sx={{
                height: "100%",
                bgcolor: getCardColor(lightMode, tenancyData.enableMfa)
            }}
        >
            <Box sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between"
            }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Require users to set up multi-factor authentication for enhanced security">
                        <IconButton>
                            <HelpIcon sx={{ color: "secondary.main" }} />
                        </IconButton>
                    </Tooltip>
                    <Typography variant="h5">
                        Multi-Factor Authentication
                    </Typography>
                </Box>
                <LoadingSwitch
                    checked={tenancyData.enableMfa || false}
                    onChange={() => onSwitchChange('enableMfa')}
                    loading={loadingStates.enableMfa}
                    disabled={isAnySwitchLoading(loadingStates)}
                    inputProps={{ "aria-label": "Multi-Factor Authentication toggle" }}
                />
            </Box>
        </MainCard>
    );
}